import { render, staticRenderFns } from "./titleAndDescription.vue?vue&type=template&id=91f301b2&scoped=true&"
import script from "./titleAndDescription.vue?vue&type=script&lang=js&"
export * from "./titleAndDescription.vue?vue&type=script&lang=js&"
import style0 from "./titleAndDescription.vue?vue&type=style&index=0&id=91f301b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f301b2",
  null
  
)

export default component.exports